import clsx from "clsx";
import { Trans, useTranslation } from "react-i18next";
import { Btn } from "@/ui/btn/Btn";
import { useMedia } from "@/hooks/useMedia";
import { useCalculator } from "../../hooks/useCalculator";
import styles from "./CalculatorToggle.module.css";

export const CalculatorCustomToggle: React.FC<{
  className?: string;
}> = ({ className }) => {
  const { t } = useTranslation();
  const setCustomActive = useCalculator((state) => state.setCustomActive);
  const sm = useMedia("<sm");

  return (
    <div className={clsx(styles.toggle, className)}>
      <div className={styles.title}>
        <Trans>Custom</Trans>
      </div>
      <div className={styles.text}>
        <Trans>Create a custom module pack to fit your needs</Trans>
      </div>
      <Btn
        text={t("Choose Modules")}
        color="primary-light"
        size={sm ? "sm" : "md"}
        onClick={() => {
          setCustomActive(true);
        }}
      />
    </div>
  );
};
